export default __webpack_public_path__ + "static/media/signupIcon.e845e55a.png";